import type { LctDb, PhotoRecord } from './db';

/** Album photo pixels (content-schemas §11.1 `photos`); the save only keeps the id list. */
export class PhotoRepository {
  constructor(private readonly db: LctDb) {}

  async put(photo: PhotoRecord): Promise<void> {
    await this.db.photos.put(photo);
  }

  get(id: string): Promise<PhotoRecord | undefined> {
    return this.db.photos.get(id);
  }

  /** Photos of one save, newest first. */
  async list(saveId: string): Promise<PhotoRecord[]> {
    const rows = await this.db.photos.where('saveId').equals(saveId).toArray();
    return rows.sort((a, b) => b.createdAt - a.createdAt);
  }

  async delete(id: string): Promise<void> {
    await this.db.photos.delete(id);
  }
}
